module.exports = __webpack_public_path__ + "static/media/arrow-4.f106dee1.png";